// -*- Mode: rjsx -*-
import React, { useState } from 'react';

import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import Grid from '@mui/material/Grid';
import List from '@mui/material/List';


import PersonIcon from '@mui/icons-material/Person';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';

import { AdminDetail } from '../../../ui';


function AddressDetail() {

}


function Details(props) {

	let user = props.user;
    let titleProps = props.titleProps; // ugh

    return (
        <Card>
          <CardHeader title="Client Details" titleTypographyProps={titleProps} />
          <CardContent>
            <Grid container>

              <Grid item style={{width: "100%"}}>
                
                <List dense={true}>

                  <AdminDetail
                    label="Name"
                    value={user.name}
                    icon={<PersonIcon />} />

                  <AdminDetail
                    label="Email"
                    value={user.email}
                    icon={<EmailIcon />} />

                  <AdminDetail
                    label="Phone"
                    value={user.phone_number}
                    icon={<PhoneIcon />} />

                  <AdminDetail
                    label="Home Address"
                    value={user.phone_number}
                    icon={<PhoneIcon />} />
                  
                </List>
              </Grid>
            </Grid>            
          </CardContent>
        </Card>
		
	);
    
    
}

export default Details;
